<template>
  <div>
    <!-- Collapse Parent -->
    <div
        class="nav-link d-flex align-items-center justify-content-between"
        :class="isActiveGroup ? `bg-gradient-${color} text-white` : ''"
        v-if="children"
        @click="toggleCollapse"
        style="cursor: pointer"
    >
      <div class="d-flex align-items-center">
        <slot name="icon" />
        <span class="nav-link-text" :class="isRTL ? 'me-1' : 'ms-1'">{{ navText }}</span>
      </div>
      <i class="material-icons-round">{{ isOpen ? 'expand_less' : 'expand_more' }}</i>
    </div>

    <!-- Collapse Children -->
    <div v-if="children && isOpen">
      <sidenav-collapse
          v-for="(child, index) in children"
          :key="index"
          :to="child.to"
          :navText="child.navText"
          :activeRoute="child.activeRoute"
      >
        <template #icon>
          <i class="material-icons-round opacity-10 fs-5">{{ child.icon }}</i>
        </template>
      </sidenav-collapse>
    </div>


    <!-- Regular Link -->
    <router-link
        v-if="!children"
        :to="to"
        class="nav-link"
        :class="getRoute() === activeRoute ? `active bg-gradient-${color}` : ''"
        v-bind="$attrs"
        @click="closeSidenav"
    >
      <slot name="icon" />
      <span class="nav-link-text" :class="isRTL ? 'me-1' : 'ms-1'">{{ navText }}</span>
    </router-link>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "SidenavCollapse",
  props: {
    to: String,
    navText: { type: String, required: true },
    activeRoute: String,
    children: Array, // New: list of sub-items
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    ...mapState(["isRTL", "color"]),
    isActiveGroup() {
      const current = this.getRoute();
      return this.children?.some((c) => c.activeRoute === current);
    },
  },
  methods: {
    ...mapMutations(["closeSidenav"]),
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    toggleCollapse() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>
